import { all, takeEvery, put, call } from "redux-saga/effects";
import { AUTH_LOGIN } from "./types";
import { toast } from "react-toastify";
import {
  loginUserFailure,
  loginUserRequest,
  loginUserSuccess,
} from "../auth/action";
import userLogin from "../../services/authServices";
import { useDispatch } from "react-redux";
import { selectedDistributor } from "../Distributor/action";
import { selectRetailerRequesterId } from "../RequesterId/action";

const superAdmin = process.env.REACT_APP_ISSUPERADMIN
var superAdminList = JSON.parse(superAdmin);
export function* userLoginSaga({ payload }) {
  yield put(loginUserRequest());

  try {
    const result = yield call(userLogin, payload);
   
    if (result) {
      
      const distributors = payload.distributerList
     // console.log('result', result)
     
      
      //console.log('distributors', distributors)
     // console.log('payload', payload)
      //console.log('payload.isAdmin', payload.isAdmin)
      const filterDist= distributors.filter(val=>val.id === payload?.values?.id)
      yield put(loginUserSuccess(result));
      yield payload.isAdmin ? payload?.navigate('/retailer-list') : payload?.navigate('/mobile-recharge');
      yield payload.dispatch(selectedDistributor(filterDist.length == 0 ? {id:null, requesterId:null,role:null}  : filterDist[0] ));
      yield payload.dispatch(selectRetailerRequesterId({reqId:result?.header?.requesterId !== undefined && result?.header?.requesterId !== null ? result?.header?.requesterId : null,id:payload.values.id}));
      toast.success("logged in Successfully");
      if(superAdminList.includes(payload.values.id)){
        localStorage.removeItem('requesterId')  
      }else{
        localStorage.setItem('requesterId',result?.header?.requesterId)
      }
    } 
  } catch (error) {
    yield put(loginUserFailure(error.response.data.response.displayMsg));
  }
}

export default function* authSaga() {
  
  yield all([takeEvery(AUTH_LOGIN, userLoginSaga )]);
}


